export default __webpack_public_path__ + "static/media/eye-regular.76d040e4.svg";